export enum PlexingEnum {
    SINGLEPLEX = 1,
    MULTIPLEX = 2,
}

export const plexingText = {
    [PlexingEnum.SINGLEPLEX]: 'Singleplex',
    [PlexingEnum.MULTIPLEX]: 'Multiplex',
};

export const plexingOptions = [
    {
        value: PlexingEnum.SINGLEPLEX,
        text: 'Singleplex',
    },
    {
        value: PlexingEnum.MULTIPLEX,
        text: 'Multiplex',
    },
];
